
import {
  FiAlertTriangle,
  FiChevronRight,
  FiEdit2,
  FiFileText,
  FiImage,
  FiLink,
  FiType,
} from 'react-icons/fi'

export const getPredefineMessageFileType = (shortcut) => {
  const tags = [];

  // Link
  if (shortcut.replacement_link?.length > 0) {
    tags.push({
      key: "link",
      label: "Link",
      icon: <FiLink size={12} />,
      className: "bg-blue-50 text-blue-800",
    });
  }

  // Files
  if (shortcut.file_name?.length > 0) {
    const fileTypes = [...new Set(shortcut.file_name.map(f => f.file_type))];

    fileTypes.forEach((type) => {
      switch (type) {
        case "image":
          tags.push({
            key: "image",
            label: "Image",
            icon: <FiImage size={12} />,
            className: "bg-green-50 text-green-800",
          });
          break;

        case "document":
          tags.push({
            key: "document",
            label: "Document",
            icon: <FiFileText size={12} />,
            className: "bg-amber-50 text-amber-800",
          });
          break;

        default:
          tags.push({
            key: "file",
            label: "File",
            icon: <FiFileText size={12} />,
            className: "bg-amber-50 text-amber-800",
          });
      }
    });
  }

  // Plain text
  if (tags.length === 0) {
    tags.push({
      key: "text",
      label: "Text",
      icon: <FiType size={12} />,
      className: "bg-gray-100 text-gray-800",
    });
  }

  return tags;
};
